"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.FormattedComposite = void 0;
var _react = _interopRequireDefault(require("react"));
var _formatters = require("./formatters");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */

// import PropTypes from 'prop-types';
const Mustache = require('mustache');

/** 
  - Passed through a configuration display format and a data oject that matches
**/

const FormattedComposite = ({
  config,
  data,
  labels,
  ...props
}) => {
  const withNulls = {};
  Object.entries(data).map(([key, value]) => {
    if (typeof value === 'object' && value.hasOwnProperty('value')) {
      withNulls[key] = value == null ? void 0 : value.value;
    } else {
      withNulls[key] = value;
    }
    return withNulls;
  });
  const constructedData = {};
  Object.entries(withNulls).map(([key, value]) => {
    if (value != null || value != '' || value != undefined) {
      constructedData[key] = value;
    }
    return constructedData;
  });
  const {
    format,
    mustacheFormatters
  } = config;
  var dataObj = {
    ...constructedData,
    ..._formatters.builtInFormatters
  };
  if (mustacheFormatters) {
    dataObj = {
      ...constructedData,
      ...mustacheFormatters,
      ..._formatters.builtInFormatters
    };
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "ccl-e-formatted-composite",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: Mustache.render(format, dataObj)
      }
    })
  });
};
exports.FormattedComposite = FormattedComposite;
var _default = exports.default = FormattedComposite;